import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import useStore from "../../lib/store";

const FloatingWindow = () => {
  const { floatingWindow, closeFloatingWindow } = useStore();

  // Escape to close
  useEffect(() => {
    if (!floatingWindow) return;
    const handler = (e) => {
      if (e.key === "Escape") closeFloatingWindow();
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [floatingWindow, closeFloatingWindow]);

  return (
    <AnimatePresence>
      {floatingWindow && (
        <motion.div
          className="floating-backdrop"
          onClick={closeFloatingWindow}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.15 }}
        >
          <motion.div
            className="floating-window"
            onClick={(e) => e.stopPropagation()}
            initial={{ opacity: 0, scale: 0.92 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.92 }}
            transition={{ duration: 0.18 }}
          >
            <div className="floating-header">
              <span className="floating-title">{floatingWindow.title}</span>
              <button
                type="button"
                className="floating-close"
                onClick={closeFloatingWindow}
              >
                ×
              </button>
            </div>
            <div className="floating-body">{floatingWindow.content}</div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default FloatingWindow;